import { useSetState } from '@domain-group/react-hooks'

import { Form, Grid, Link } from '@domain-group/suit-theme'

import useBulkSelectImages from '@modals/BulkSelectImagesModal/hooks/useBulkSelectImages'

import Thumbnail from './Thumbnail'

const defaultState = {
  viewMode: 'small' as 'small' | 'large',
}

const tileSizes = {
  large: {
    width: 320,
    height: 200,
  },
  small: {
    width: 150,
    height: 110,
  },
}

interface ImagesProps {
  bulkSelectImagesPayload: ReturnType<typeof useBulkSelectImages>,
}

const ImagesView = (props: ImagesProps) => {
  const [state, setState] = useSetState(defaultState)
  const { viewMode } = state

  const { bulkSelectImagesPayload } = props

  const {
    callbacks: { selectId },
    deletedImageIds,
    filteredImages: images,
    selectedEntityIds,
  } = bulkSelectImagesPayload

  const tileSize = tileSizes[viewMode] || {}

  return (
    <Form.Field
      direction="column"
      label="Images"
      labelRight={(
        <Link
          onClick={() => setState({ viewMode: viewMode === 'large' ? 'small' : 'large' })}
          textProps={{ fontSize: 'xsmall' }}
        >
          {viewMode === 'large' ? 'View Small Tiles' : 'View Large Tiles'}
        </Link>
      )}
    >
      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridAutoRows="1fr"
        gridTemplateColumns={`repeat(auto-fill, minmax(${tileSize.width}px, 1fr))`}
        gridTemplateRows={`repeat(auto-fill, minmax(${tileSize.height}px, 1fr))`}
      >
        {images.map((image) => {
          const selectionIndex = selectedEntityIds.findIndex(id => image.id === id)

          return (
            <Thumbnail
              callbacks={{ selectImageId: selectId }}
              key={image.id}
              image={image}
              selectionIndex={selectionIndex}
              viewMode={viewMode}
            />
          )
        })}

        {deletedImageIds.map((deletedImageId) => {
          const selectionIndex = selectedEntityIds.findIndex(id => deletedImageId === id)

          return (
            <Thumbnail
              callbacks={{ selectImageId: selectId }}
              key={deletedImageId}
              // @ts-expect-error TS2739
              image={{ id: deletedImageId }}
              selectionIndex={selectionIndex}
              viewMode={viewMode}
            />
          )
        })}
      </Grid>
    </Form.Field>
  )
}
export default ImagesView
